export const PlatformTypeEnum = {
    TYPE_WEB: 1
} as const
